import script from "./StorySlide.vue?vue&type=script&setup=true&lang=js"
export * from "./StorySlide.vue?vue&type=script&setup=true&lang=js"

import "./StorySlide.vue?vue&type=style&index=0&id=6eedb972&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6eedb972"]])

export default __exports__